"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immutable_1 = require("immutable");
const Pricing_1 = require("../Pricing");
const Pricing_2 = require("../Pricing");
const SupportingCreativeFormatCreativeType_1 = require("./SupportingCreativeFormatCreativeType");
class SupportingCreativeFormatPlacement {
    constructor({ id, key, name, creativeTypes, pricingTables, basicMerchandises, }) {
        this.toJSON = () => ({
            id: this.id,
            key: this.key,
            name: this.name,
            creativeTypes: this.creativeTypes.toJSON(),
            pricingTables: this.pricingTables,
            basicMerchandises: this.basicMerchandises,
        });
        this.id = id;
        this.key = key;
        this.name = name;
        this.creativeTypes = creativeTypes;
        this.pricingTables = pricingTables;
        this.basicMerchandises = basicMerchandises;
    }
}
SupportingCreativeFormatPlacement.fromJSON = (json) => {
    const { id, key, name, creativeTypes, pricingTables, basicMerchandises } = Object.assign({}, json);
    if (typeof id !== 'string')
        throw new Error('.id must be a string');
    if (typeof key !== 'string')
        throw new Error('.key must be a string');
    if (typeof name !== 'string')
        throw new Error('.name must be a string');
    if (!Array.isArray(creativeTypes))
        throw new Error('.creativeTypes must be an array');
    return new SupportingCreativeFormatPlacement({
        id,
        key,
        name,
        creativeTypes: immutable_1.List(creativeTypes).map(item => SupportingCreativeFormatCreativeType_1.default.fromJSON(item)),
        pricingTables: pricingTables
            ? pricingTables.map((_pricingTable) => Pricing_2.PricingTable.fromJSON(_pricingTable))
            : null,
        basicMerchandises: basicMerchandises
            ? basicMerchandises.map((_basicMerchandise) => Pricing_1.PricingMerchandiseBasic.fromJSON(_basicMerchandise))
            : undefined,
    });
};
exports.default = SupportingCreativeFormatPlacement;
